var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-draw-dark"},[_c('div',{attrs:{"id":"drawingmap-dark-mood"}},[_c('div',{staticClass:"btn-group-vertical"},[_c('button',{staticClass:"btn btn-sm btn-link dark-mood bg-white",on:{"click":() => {
            _vm.setTheme(!_vm.dark);
          }}},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.dark)?_c('i',{staticClass:"fas fa-sun text-warning"}):_c('i',{staticClass:"fas fa-moon text-dark"})])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }